import React from "react";
import { Link } from "gatsby";

const linkClass = "h-11 inline-flex items-center gap-2 px-[18px] border-l border-white/10 text-[11px] font-medium text-white/80 transition-colors duration-200 hover:text-white";

/**
 * Barra superior oscura. Sin sesión anuncia las promociones vigentes; con
 * sesión se convierte en la barra de accesos operativos del cliente.
 */
const Topbar = ({ isAuthenticated, hasPriceList, onSearchOpen, onLogout }) => {

	if (!isAuthenticated) {
		return (
			<div className="relative z-40 bg-ink text-white/80" aria-label="Información destacada">
				<div className="shell flex min-h-[39px] items-center justify-between gap-6 text-[11px] tracking-[.025em]">
					<Link to="/#promociones" className="inline-flex items-center gap-2.5 transition-colors duration-200 hover:text-white">
						<span className="h-1.5 w-1.5 flex-none rounded-full bg-accent-lime shadow-[0_0_0_4px_rgba(185,239,55,.12)]" aria-hidden="true"></span>
						<strong className="font-semibold text-white">Promociones vigentes</strong>
					</Link>
					<span className="font-semibold text-white">Acceso clientes</span>
				</div>
			</div>
		);
	}

	return (
		<div className="relative z-40 bg-ink text-white/80" aria-label="Accesos de cliente">
			<div className="shell flex min-h-[44px] items-center justify-between gap-6">
				<span className="inline-flex items-center gap-2.5 text-[9px] font-bold uppercase tracking-[.11em] text-white/60">
					<span className="h-1.5 w-1.5 flex-none rounded-full bg-accent-lime shadow-[0_0_0_4px_rgba(185,239,55,.12)]" aria-hidden="true"></span>
					Área de clientes
				</span>

				<nav className="hidden h-11 items-center sm:flex" aria-label="Accesos operativos">
					{
						hasPriceList &&
							<Link to="/lista-de-precios" className={ linkClass }>Lista de precios</Link>
					}
					<button type="button" onClick={ onSearchOpen } className={ linkClass }>
						<svg viewBox="0 0 24 24" aria-hidden="true" className="h-[15px] w-[15px] fill-none stroke-current" strokeWidth={1.8}>
							<circle cx="11" cy="11" r="6.5"></circle>
							<path d="m16 16 4.2 4.2"></path>
						</svg>
						Buscar
					</button>
					<button type="button" onClick={ onLogout } className={ `${linkClass} !text-white` }>Cerrar sesión</button>
				</nav>
			</div>
		</div>
	);
};

export default Topbar;
